/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IIntraOPNursingRecord } from 'app/shared/model/intra-op-nursing-record.model';
import { PackType } from 'app/shared/model/enumerations/pack-type.model';

export interface IIntraOPPack {
  id?: string;
  packType?: keyof typeof PackType | null;
  tmSize?: string | null;
  site?: string | null;
  amount?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  nursingRecord?: IIntraOPNursingRecord;
}

export const defaultValue: Readonly<IIntraOPPack> = {
  active: false,
};
